<template>
	<div class="page_content explore_entity_inside program" aria-label="program guide enrollments">

		<div class="row page-heading">
      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
        		<span class="module_icon icon-list"></span>
        		<label v-if="formattedProgramGuide && formattedProgramGuide.title" id="programGuideTitle" class="head_txt module_type_name">
          			Program: {{formattedProgramGuide.title}}
        		</label>
        		<label v-else id="programGuideTitle" class="head_txt module_type_name">Program: {{formattedCareer.name}}</label>
      		</div>

      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 btn_container">
        		<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
              <span class="btn_ic ic-back"></span>
              <span class="btn_txt"> {{ deCamelCase() }} </span>
            </b-btn>
      		</div>
    </div>
    <div class="page_content_container">
        <div v-if="formattedProgramGuide && formattedProgramGuide.title">
            <program-guide-menu
                :cipCode="formattedProgramGuide.cipCode"
                :programGuideCode="formattedProgramGuide.code"
                :type="formattedProgramGuide.type"
                :returnTo="returnTo"
                :active="'enrollment'">
            </program-guide-menu>
        </div>
        <div class="pg_content">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
              <div class="row pg_sec">
                    <div class="col-6 hd ace_sec_hd" aria-label="Jobs">
                        <h2>Enrollments</h2>
                        <span class="hd_bdr"></span>
                    </div>
                    <div class="col-6 hd ace_sec_hd" aria-label="Jobs">
                      <b-btn @click.stop.prevent="reProcessStructure(true)" aria-label="Dry Run Re Process Structure" v-if="formattedProgramGuide.trackCertificate && enrollments.length > 0">
                        <span class="btn_ic ic-back"></span>
                        <span class="btn_txt"> Dry Run  </span>
                      </b-btn>

                      <b-btn @click.stop.prevent="reProcessStructure(false)" aria-label="Re Process Structure" v-if="formattedProgramGuide.trackCertificate && enrollments.length > 0">
                        <span class="btn_ic ic-back"></span>
                        <span class="btn_txt"> convert for all users </span>
                      </b-btn>
                      <b-btn @click.stop.prevent="convertProgramStructure(true)" aria-label="Convert Program Structure" v-if="!formattedProgramGuide.trackCertificate">
                          <span class="btn_ic ic-back"></span>
                          <span class="btn_txt"> Dry Run </span>
                      </b-btn>
                      <b-btn @click.stop.prevent="convertProgramStructure(false)" aria-label="Convert Program Structure" v-if="!formattedProgramGuide.trackCertificate">
                          <span class="btn_ic ic-back"></span>
                          <span class="btn_txt"> Convert Program Structure </span>
                      </b-btn>

                    </div>

                    <div class="col-12 sec_content">
                      <div class="course-management-section">
                          <div class="course-management-table-container">
                              <table class="table b-table table-bordered border">
                                  <thead class="thead-light text-center">
                                      <tr>
                                        <th class="second-column">Name</th>
                                        <th class="third-column">Enrollment Date </th>
                                        <th class="third-column">New Format </th>
                                      </tr>
                                  </thead>
                                  <tbody v-if="enrollments.length > 0">
                                      <tr v-for="enrollment in enrollments">
                                          <td class="second-column col_title">
                                              {{ enrollment.uuid }}
                                          </td>
                                          <td class="third-column col_owner">{{ getFormattedDateTime(enrollment.lastUpdatedTime) }}
                                          </td>
                                          <td class="third-column col_owner">
                                            <b-btn @click.stop.prevent="convert(enrollment, true)" aria-label="Dry Run">
                                              <span class="btn_txt"> Dry Run </span>
                                            </b-btn>
                                            <b-btn @click.stop.prevent="convert(enrollment, false)" aria-label="convert">
                                              <span class="btn_txt"> convert </span>
                                            </b-btn>
                                           </td>
                                      </tr>
                                  </tbody>
                                  <tbody v-else>
                                      <tr>
                                        <td colspan="2" class="no-result" style="text-align: center;">
                                          There are no enrollments yet.
                                        </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                    </div>

              </div> <!-- .pg_sec -->
            </div>
        </div> <!-- .pg_content -->
    </div> <!-- .page_content_container -->
	</div>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideSummary from './ProgramGuideSummary'

export default {
  name: 'program-guide-enrollments',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideSummary
  },
  data: () => {
    return {
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'exploreIntro',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      enrollments : []
    }
  },

  async mounted () {
    this.loadEnroomentDataForProgram()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideEnrollments',
      'processProgramGuideStructure',
      'processConvertStructure',
      'processConvertProgram'
    ]),
      getFormattedDateTime (timeInMillis) {
        if (timeInMillis === 0) {
          return 'N/A'
        }
        var d
        var str = ''
        d = new Date(timeInMillis)
        str += String(this.months[d.getMonth()])
        str += ' ' + d.getDate()
        str += ', ' + d.getFullYear()
        var amPm = ''
        var currHour = d.getHours()
        if (currHour < 12) {
          amPm = 'AM'
        } else {
          amPm = 'PM'
        }
        if (currHour === 0) {
          currHour = 12
        }
        if (currHour > 12) {
          currHour = currHour - 12
        }
        var currMin = d.getMinutes()
        currMin = currMin + ''
        if (currMin.length === 1) {
          currMin = '0' + currMin
        }
        str += ' ' + currHour
        str += ':' + currMin
        str += ' ' + amPm
        return str
      },
    async loadEnroomentDataForProgram () {
        this.enrollments = await this.loadProgramGuideEnrollments({ cipCode: this.programGuide.cipCode, code: this.programGuide.code })
    },
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    async convert (enrollmentObj, dryRun){
        let response = await this.processConvertStructure({ userId: enrollmentObj.userId, code: this.programGuide.code, dryRun:dryRun })
        let message = 'Successfully converted format for user.'
        if(dryRun){
            message = 'Successfully perform dry run for user, please check email.'
        }
        if(response==='Success') {
          this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: message
              })

        }else{
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'errors while performing operation.'
          })
        }
    },
    
    async reProcessStructure (dryRun) {
        let response = await this.processProgramGuideStructure({ cipCode: this.programGuide.cipCode, code: this.programGuide.code, dryRun:dryRun })
        let message = 'Successfully converted format for users.'
        if(dryRun){
            message = 'Successfully perform dry run for users, please check email.'
        }
        if(response==='Success') {
          this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: message
              })

        }else{
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'errors while performing operation.'
          })
        }
    },
    async convertProgramStructure (dryRun) {
        let response = await this.processConvertProgram({ code: this.programGuide.code, dryRun:dryRun })
        let message = 'Successfully converted Program Structure'
        if(dryRun){
            message = 'Successfully perform dry convertion Program Structure.'
        }
        if(response==='Success') {
          this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: message
              })

        }else{
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'errors while performing operation.'
          })
        }
        let routerParams = {
        cipCode: this.programGuide.cipCode,
        programGuideCode: this.programGuide.code,
        type: this.programGuide.type,
        returnTo: this.returnTo || 'exploreProgramGuideResults',
        showBackToResultButton: true
      }
      return this.$router.push({ name: 'programGuideIntroduction', params: this.programGuideRouterParams })
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'packages': state => state.institution.packages
    }),
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuide
      return formattedProgramGuide
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideEnrollment.vue